(() => {
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  document.querySelectorAll('header-menu details[data-shop-all-menu]').forEach((details) => {
    const summary = details.querySelector(':scope > summary');
    if (!summary || details.dataset.shopAllHoverBound === 'true') return;

    details.dataset.shopAllHoverBound = 'true';

    details.addEventListener('pointerenter', (event) => {
      if (!desktopHover.matches || event.pointerType !== 'mouse') return;

      details.open = true;
      summary.setAttribute('aria-expanded', 'true');
    });

    details.addEventListener('pointerleave', (event) => {
      if (!desktopHover.matches || event.pointerType !== 'mouse') return;
      if (details.contains(document.activeElement)) return;

      details.open = false;
      summary.setAttribute('aria-expanded', 'false');
    });
  });
})();
